import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import Select from 'react-select';
import "./field.scss";

const SearchableSelectForInvites = ({
  inputValue,
  handleChangeCode,
  handleOnBlur,
  errorOccured,
  isEnteringNumber,
  errorMessage,
  defaultCodeValue,
  handleChangeSearchValue,
  isLoading,
  userArray,
  labelName = "Select user",
}) => {
  const [activated, setActivated] = useState(true);
  const labelRef = useRef(null);
  const inputRef = useRef(null);
  const [coverWidth, setCoverWidth] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);

  // New constant array with label as 'email_chr' and value as 'user_id_ids'
  // const userArray = [
  //   {
  //     user_id_ids: "edd7e109286a45279fa24647c4508829",
  //     email_chr: "newp+1@yopmail.com",
  //   },
  //   {
  //     user_id_ids: "660000d92f954c798ef0ca3cb98fcee9",
  //     email_chr: "devcust1@yopmail.com",
  //   },
  //   {
  //     user_id_ids: "ee47383a71d040ab831724e68a078f8c",
  //     email_chr: "newp@yopmail.com",
  //   },
  //   {
  //     user_id_ids: "4ed1eb8b55c84a4d8cdf8593767afc08",
  //     email_chr: "anuj.goutam+06@upkarak.com",
  //   },
  //   {
  //     user_id_ids: "10",
  //     email_chr: "anuj.goutam@upkarak.com",
  //   },
  //   {
  //     user_id_ids: "219",
  //     email_chr: "customer1@chilll.com",
  //   },
  //   {
  //     user_id_ids: "218",
  //     email_chr: "allpro1@chilll.com",
  //   },
  //   {
  //     user_id_ids: "5",
  //     email_chr: "td@yopmail.com",
  //   },
  //   {
  //     user_id_ids: "280",
  //     email_chr: "Honey.mishra+admin@upkarak.com",
  //   },
  //   {
  //     user_id_ids: "f1e8de004e86467bbbb47f911037d38f",
  //     email_chr: "sahil.hooda+free_trial01@upkarak.com",
  //   }
  // ];

  // Set the width of the label cover dynamically based on label width
  useEffect(() => {
    setCoverWidth(
      labelRef.current ? labelRef.current.getBoundingClientRect().width + 11 : 0
    );
    if (isEnteringNumber || inputValue?.length > 0) {
      setActivated(true);
    }
  }, [labelRef]);

  // Handle onBlur logic for input field
  function onBlurCheckInput() {
    handleOnBlur();
    if (inputValue?.length > 0 || isEnteringNumber) {
      setActivated(true);
    } else {
      setActivated(true);
    }
  }

  const onBlurFn = () => {
    if (inputValue.length > 0 || isEnteringNumber) {
      onBlurCheckInput();
    } else {
      setActivated(true);
    }
  };

  // Prepare options for the Select dropdown
  const options = userArray.map(user => ({
    // value: user.user_id_ids,
    value: user,
    label: `${user?.first_name_chr ? user?.first_name_chr : ''} (${user?.email_chr ? user?.email_chr : user?.phone_number_int ? user?.phone_number_int : ''})`,
  }));

  // Set default option based on defaultCodeValue
  useEffect(() => {
    const defaultOption = options.find(option => option.value === defaultCodeValue);
    if (defaultOption) {
      setSelectedOption(defaultOption);
    }
  }, [defaultCodeValue, options]);

  // Handle selection in the dropdown
  const handleSelectChange = option => {
    setSelectedOption(option);
    if (handleChangeCode) {
      handleChangeCode(option.value);
    }
  };

  // Custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      // border: state.isFocused ? '1px solid #ced4da' : '1px solid #ced4da',
      border: errorOccured ? '1px solid red' : '1px solid #ced4da',
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0)' : 'none',
      width: '100%',
      marginRight: '5px',
      padding: '1px 3px',
      '&:hover': {
        border: '1px solid orange'
      },
      menu: (provided) => ({
        ...provided,
        zIndex: 5,
      })
    })
  };

  const customComponents = {
    // DropdownIndicator: null,
    // IndicatorSeparator: null,
  };

  return (
    <div className="mt-3">
      <div className="d-flex" style={{ justifyContent: 'space-between' }}>
        <InputGroup
          ref={inputRef}
          className={errorOccured ? "" : "mb-3"}
          onFocus={() => setActivated(true)}
          style={{ width: '100%' }}
          onBlur={onBlurFn}
        >
          <Form.Group controlId="exampleForm.SelectCustom" style={{ width: '100%' }}>
            <Form.Label
              className={`${activated || inputValue?.length > 0
                ? "textfield-label-activated"
                : "textfield-label-unactivated"
                } textfield-label  ${errorOccured && 'text-danger'}`}
              ref={labelRef}
              onClick={() => {
                setActivated(true);
                inputRef?.current.focus();
              }}
              style={{ zIndex: 20 }}
            >
              <strong> {labelName}</strong>
            </Form.Label>
            <div
              className={`${activated || inputValue?.length > 0
                ? "textfield-label-cover-activated"
                : "textfield-label-cover-unactivated"
                } textfield-label-cover`}
              style={{ zIndex: 19, width: '70px' }}
            ></div>

            <Select
              onInputChange={handleChangeSearchValue}
              options={options}
              onChange={handleSelectChange}
              value={selectedOption}
              isSearchable={true}
              placeholder="User@example.com"
              styles={customStyles}
              components={customComponents}
              className="custom-select-menu"
              noOptionsMessage={() => (isLoading ? "Searching..." : "No match found")}
            />
          </Form.Group>
        </InputGroup>
      </div>
      {errorOccured && (
        <div className={`${!errorOccured ? "" : "mb-3"} text-danger fs-12`}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default SearchableSelectForInvites;
